import {Component, OnInit, Input, ViewContainerRef} from '@angular/core';
import {trigger, transition, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {ConfirmdialogComponent} from '../../common/dialog/confirmdialog.component';
import {ApirequestService} from '../../../services/apirequest/apirequest.service';
import {ApiurlsService} from '../../../services/api-urls/apiurls.service';
import {Router} from '@angular/router';
import {UtilityService} from '../../../services/utilities/utilities.services';
import {OrderPipe} from 'ngx-order-pipe';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {FormGroup, FormBuilder} from '@angular/forms';


@Component({
  selector: 'hybse-admin-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class CompanyComponent implements OnInit {
  voucherForm: FormGroup;
  showLoader = true;
  voucherList: any = [];
  paginatorList: any = [];
  public paginatorCount: number;
  fadeInDown: any;
  public errorMessage: string;
  listTitle = 'All Vouchers - Unredeemed';
  public count: number;
  public limit = 50;
  public offset = 0;
  public filterType: number;
  public pageIndex: number = 0;
  public isInit: boolean = false;

  // sorting
  reverse = false;
  order = 'createdat';
  sortedCollection: any[];

  constructor(public dialog: MatDialog,
              public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcr: ViewContainerRef,
              private _fb: FormBuilder,
              private orderPipe: OrderPipe) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.getVoucherList(false);
    this.voucherFormInit();
    this.sortedCollection = this.orderPipe.transform(this.voucherList, this.order);
  }

  voucherFormInit() {
    this.voucherForm = this._fb.group({
      filter: ['']
    });
  }

  getVoucherList(formSubmit) {
    let data = {};
    if (!formSubmit) {
      data = {
        offset: this.offset,
        limit: this.limit,
      };
    } else {
      data = {
        ...this.voucherForm.value,
        offset: 0,
        limit: this.limit,
      };
      this.voucherForm.patchValue({
        filter: ''
      });
    }

    this.voucherList = [];
    this._api.fetchApiData(this._urls.voucherListUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const resErr = res.error;
        if (response !== '') {
          this.voucherList = response.couponList;
          this.count = response.count;
        } else {
          this.errorMessage = resErr['errorDescription'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        if (!this.isInit) {
          this.paginatorList = this.voucherList;
          this.paginatorCount = this.count;
          this.isInit = true;
        }
      }
    );
  }

  voucherSubmit() {
    if (this.voucherForm.valid) {
      this.showLoader = true;
      this.getVoucherList(true);
    }
  }

  confirmArchive(id) {
    const deleteDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: 'Are you sure to archive this voucher?'
      }
    });

    deleteDialog.afterClosed().subscribe(
      data => {
        if (data) {
          this.archiveVoucher(id);
        }
      }
    );
  }

  checkActive(active, type) {
    if (active) {
      return type === 'bool' ? true : 'Active';
    } else {
      return type === 'bool' ? false : 'Inactive';
    }
  }

  toggleActive(voucher, e) {
    const status = e.checked ? 'Active' : 'Inactive';
    let message = '';

    if (!voucher.isRedeemed) {
      message = 'Are you sure to ' + status + ' the ' + voucher.referenceCode + '?';
    } else {
      message = 'You are not allowed to deactivate a redeemed voucher!';
    }

    const activeDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: message
      }
    });

    if (!voucher.isRedeemed) {
      activeDialog.afterClosed().subscribe(
        data => {
          if (data) {
            this.toggleActiveNews(voucher.idCouponCode, e);
          }
        }
      );
    }
  }

  toggleActiveNews(id, e) {
    const data = {
      idCouponCode: id
    };
    let endpointUrl = '';

    if (e.checked) {
      endpointUrl = this._urls.voucherActivateUrl;
    } else {
      endpointUrl = this._urls.voucherDeactivateUrl;
    }

    this._api.fetchApiData(endpointUrl, data).subscribe(
      (res: any) => {
        const message = res.data['Success Description'];
        if (Object.keys(res.data).length > 0) {
          this.voucherList = this._utils.changeArrayObjProp(this.voucherList, 'idCouponCode', id, 'isActive', e.checked);
          this.toastr.success(message, 'Success!');
        }
      },
      error => {

      },
      () => {

      }
    );
  }

  pagination(e) {
    this.pageIndex = e.pageIndex;
    this.offset = (this.pageIndex * 50);
    this.getVoucherList(false);
  }

  archiveVoucher(id) {
    const data = {idCouponCode: id, isArchive: 1};
    this._api.fetchApiData(this._urls.voucherArchiveUrl, data).subscribe(
      (res: any) => {
        const response = res;
        if (response.data.length !== 0) {
          this.toastr.success('Voucher has been archived successfully!', 'Success!');
          // this.getVoucherList(false);
          this.voucherList.splice(this.voucherList.findIndex(function (arrEl) {
            return arrEl.idCouponCode === id;
          }), 1);
        }
      },
      error => {
        this.toastr.error('Request error occurred! Contact administrator.', 'Error!');
        this.showLoader = false;
      },
      () => {

      }
    );
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    if (value === 'createdat') {
      this.showLoader = true;
      this.reverse ? this.filterType = 2 : this.filterType = 1;
      this.getVoucherList(false);
    } else if (value === 'referenceCode') {
      this.showLoader = true;
      this.reverse ? this.filterType = 3 : this.filterType = 4;
      this.getVoucherList(false);
    }
    this.order = value;
  }

  ngOnChanges() {
    this.listTitle = 'All Vouchers - Unredeemed';
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/company/company.component.ts